(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/racing/bet-summary/assets/javascripts/bet-summary.js') >= 0) return;  svs.modules.push('/components/racing/bet-summary/assets/javascripts/bet-summary.js');

'use strict';

const BetSummaryItem = svs.racing.betSummary.BetSummaryItem;
const ButtonBet = svs.components.ReactButtonBet;
const {
  gameTypes,
  gameTypeToUrlName,
  systemTypes,
  systemTypesToCssName
} = svs.racing.common.constants;
const {
  ReactIcon: Icon
} = svs.ui;
const BetSummary = _ref => {
  let {
    gameType,
    systemType,
    positions,
    reserve,
    isXpert,
    isPixPick,
    isFirstPositionLocked
  } = _ref;
  const createBetSummaryGeneral = (position, index) => {
    let positionArray = [];
    const selectionHeader = systemType === systemTypes.TOP_RANK ? "".concat(index + 1, ":a") : index + 1;

    if (!Array.isArray(position)) {
      positionArray.push(position);
    } else {
      positionArray = position;
    }
    return React.createElement("li", {
      className: "bet-summary-list-item"
,
      key: index
    }, (gameType === gameTypes.TOPP5 || gameType === gameTypes.RX4IO || gameType === gameTypes.RX3IOAO || gameType === gameTypes.RX3IO || gameType === gameTypes.RX2IO) && React.createElement("div", {
      className: "bet-summary-list-item-header"
    }, selectionHeader), React.createElement("div", {
      className: "u-flex u-flex-wrap bet-summary-list-item-wrapper"
    }, positionArray.map((pos, i) => React.createElement(BetSummaryItem, {
      isPixChoice: systemType === systemTypes.TOP_RANK_PIX && pos !== undefined ? isPixPick(index, pos) : false,
      isReserve: false
,
      key: i,
      value: pos === undefined ? '' : pos.toString()
    })), index === 0 && isFirstPositionLocked && React.createElement("div", {
      className: "bet-summary-item"
    }, React.createElement(ButtonBet, {
      animated: true,
      branding: "racing",
      className: "coupon-btn-bet-racing summary-bet-racing bet-summary-pad-lock",
      selected: true,
      type: "button"
    }, React.createElement(Icon, {
      class: "btn-bet-icon",
      icon: "lock-closed"
    })))));
  };
  const createBetSummaryTopp2 = (position, index) => {
    let currentClass = 'bet-summary-list-item';
    let positionArray = [];
    let selectionHeader = '';
    if (systemType === systemTypes.WHEEL) {
      selectionHeader = index === 0 ? 'Utgångshäst' : 'Hästar';
      currentClass = index === 0 ? 'wheel-item-u' : 'wheel-item';
    }

    if (!Array.isArray(position)) {
      positionArray.push(position);
    } else {
      positionArray = position;
    }
    return React.createElement("li", {
      className: "".concat(currentClass)
,
      key: index
    }, React.createElement("span", {
      className: "bet-summary-list-item-header"
    }, selectionHeader), React.createElement("div", {
      className: "clearfix"
    }), positionArray.map((pos, index) => React.createElement(BetSummaryItem, {
      isReserve: false
,
      key: index,
      value: pos === undefined ? '' : pos.toString()
    })));
  };
  const getBetSummary = () => {
    switch (gameType) {
      case gameTypes.TOPP2:
      case gameTypes.RX2P4:
      case gameTypes.RX2P:
        return positions.map(createBetSummaryTopp2);
      case gameTypes.RX3AO:
        return positions.map(createBetSummaryTopp2);
      case gameTypes.TOPP5:
      default:
        return positions.map(createBetSummaryGeneral);
    }
  };
  const summaryListClasses = ['bet-summary-list', "game-type-".concat(gameTypeToUrlName[gameType]), systemTypesToCssName[systemType]];
  if (isXpert) {
    summaryListClasses.push('xpert');
  }
  return React.createElement("div", {
    className: "my-bet-summary"
  }, React.createElement("div", {
    className: "bet-summary-default"
  }, React.createElement("ol", {
    className: summaryListClasses.join(' ')
  }, getBetSummary(), reserve && React.createElement("li", {
    className: "bet-summary-list-item"
,
    key: "reserve"
  }, React.createElement("div", {
    className: "clearfix"
  }), React.createElement(BetSummaryItem, {
    isReserve: true
,
    key: "reserve-horse",
    value: reserve === undefined ? '' : reserve.toString()
  })))));
};
BetSummary.defaultProps = {
  isPixPick: false
};
svs.racing.betSummary.BetSummary = BetSummary;

 })(window);